import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import Image from '@nubank/www-latam-commons/components/Image/Image';

function SectionPayments({ index }) {
  const { formatMessage } = useContext(NuDsContext);
  return (
    <Box
      tag="section"
      paddingTop={{ xs: '12x' }}
      paddingBottom={{ xs: '12x', md: '24x', lg: '32x' }}
      paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
      display={{ lg: 'grid' }}
      gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
      gridColumnGap={{ lg: '8x' }}
      alignItems={{ lg: 'center' }}
    >
      <Box gridColumn={{ lg: '2 / 6' }}>
        <Image
          altIntlKey="REQUEST.PIX.IMAGE_ALT"
          loading="lazy"
          srcSet={{
            xs: 'man-looking-at-phone/man-looking-at-phone@xs-2x.jpg',
            md: 'man-looking-at-phone/man-looking-at-phone@md-2x.jpg',
            lg: 'man-looking-at-phone/man-looking-at-phone@lg-1x.jpg',
          }}
        />
      </Box>
      <Box
        paddingTop={{ xs: '6x', md: '8x', lg: '0' }}
        gridColumn={{ lg: '7 / 12' }}
      >
        <Typography
          variant="title"
          intlKey={`cms.accountPage.cardsArea[${index}].title`}
          maxWidth={{ lg: '15ch' }}
        />
        {formatMessage({
          id: `cms.accountPage.cardsArea[${index}.description]`,
        }, {
          p: props => <Typography marginTop={{ xs: '6x', md: '8x' }} variant="subtitle" {...props} />,
        })}
        <Link
          marginTop={{ xs: '6x', md: '8x' }}
          variant="action"
          href={formatMessage({ id: `cms.accountPage.cardsArea[${index}].ctaLink` })}
          intlKey={`cms.accountPage.cardsArea[${index}].ctaText`}
        />
      </Box>
    </Box>
  );
}

SectionPayments.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionPayments);
